
import Vue from 'vue';
import Component from 'vue-class-component';
import { BoListPanel } from 'bonomo/dist';
import { namespace } from 'vuex-class';
import { IUserLog } from '@/model/logs/Ilogs';
import { Prop } from 'vue-property-decorator';
import { BetterDataTableHeader } from '@/model/betterVuetifyInterfaces';

const userModule = namespace('userModule');

interface ILogAction {
  ori?: number | string; // origin:load-data="loadData"
}

@Component({
  name: 'UserLogs',
  components: {
    BoListPanel,
  },
})
export default class UserLogs extends Vue {
  @Prop()
  protected userId!: number;

  @userModule.Getter('logs')
  private logs!: IUserLog[];

  @userModule.Action('fetchLogs')
  private fetchLogs!: ({ userId, filters }: any) => IUserLog;

  @userModule.Action('clearLogs')
  private clearLogs!: () => null;

  protected loading: boolean = false;
  protected expanded: boolean = false;

  protected get headers(): BetterDataTableHeader[] {
    return [
      {
        text: this.$t('common.when'),
        align: 'start',
        sortable: false,
        value: 'created_at',
      },
      {
        text: this.$t('common.description'),
        align: 'start',
        sortable: false,
        value: 'action',
      },
      {
        text: this.$t('common.details'),
        align: 'start',
        sortable: false,
        value: 'data',
      },
    ];
  }

  private loadData(filters: any) {
    this.fetchLogs({ userId: this.userId, filters });
  }

  private formatUserData(obj: ILogAction) {
    let newObj: ILogAction = { ...obj };
    if (newObj.ori) {
      newObj.ori =
        (this.$t('users.user.logs.origin.' + newObj['ori']) as string) || '???';
    }

    return newObj;
  }
}
